export default {
  staticHost: "https://dev-teacher.xlketang.cn",
  // staticHost: 'http://gaozhou.xlketang.cn',
  // staticHost: 'http://mac.txlt.com',

  devHost: "/dev_api",
  // devWebsocketHost:'ws://mac.txlt.com/wss',

  // devWebsocketHost:'ws://192.168.2.147/wss',
  // devHost: 'https://dev-teacher.xlketang.cn',
  devWebsocketHost: "wss://dev-teacher.xlketang.cn/wss",

  // websocketHost: 'wss://dev-teacher.xlketang.cn/wss',













};
